module.exports = __webpack_public_path__ + "img/loginBG.def82c0e.jpg";